import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useApi } from "../../lib/api";
import { PageHeader, Empty, AuthImg } from "../../components/common";

const LABELS = { blood_type: "Blood type", allergies: "Allergies", conditions: "Conditions", medication: "Medication", donor: "Organ donor",
  doctor_name: "Doctor", doctor_phone: "Doctor phone", insurance_provider: "Insurance", insurance_number: "Insurance no.", kin_name: "Next of kin", kin_relation: "Relation", kin_phone: "Kin phone" };

function Detail({ gid, pid }) {
  const api = useApi();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/groups/${gid}/nurse/people/${pid}`).then((r) => setP(r.data)); }, [api, gid, pid]);
  if (!p) return <div className="text-slate-400 text-sm">Loading…</div>;
  return (
    <div className="panel p-6" data-testid="nurse-profile-detail">
      <div className="flex items-center gap-4 mb-5">
        {p.has_photo && <AuthImg path={`/groups/${gid}/nurse/people/${pid}/photo`} className="w-16 h-16 rounded-md object-cover" />}
        <div><div className="font-display font-bold text-xl">{p.first_name} {p.last_name}</div><div className="text-xs text-slate-400">Read-only · this view is recorded in the audit log</div></div>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">{Object.entries(LABELS).map(([k, l]) => (
        <div key={k} className="rounded-md bg-slate-900/60 border border-slate-800 p-3"><div className="overline">{l}</div><div className="text-sm mt-1 whitespace-pre-wrap">{p.medical[k] || "—"}</div></div>))}</div>
    </div>
  );
}

export default function Nurse() {
  const { group } = useOutletContext();
  const api = useApi();
  const [people, setPeople] = useState(null);
  const [sel, setSel] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/groups/${group.id}/nurse/people`).then((r) => setPeople(r.data)).catch(() => setErr("Only nurses added in Settings can open this view.")); }, [api, group.id]);
  return (
    <div data-testid="nurse-page">
      <PageHeader overline="Guardian-granted access" title="Nurse view" />
      {err && <Empty testid="nurse-not-allowed">{err}</Empty>}
      {people && people.length === 0 && <Empty testid="nurse-empty">No guardian has granted nurse access yet.</Empty>}
      {people && people.length > 0 && <div className="grid lg:grid-cols-[280px_1fr] gap-6">
        <div className="panel p-2">{people.map((p) => <button key={p.id} data-testid={`nurse-person-${p.id}`} onClick={() => setSel(p.id)}
          className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors ${sel === p.id ? "bg-slate-800" : "hover:bg-slate-800/50"}`}>{p.first_name} {p.last_name}</button>)}</div>
        {sel ? <Detail key={sel} gid={group.id} pid={sel} /> : <Empty>Select a person.</Empty>}
      </div>}
    </div>
  );
}
